import { useContext, useState, useEffect, useRef } from "react";
import { Language } from "../../App";

export const ReadMore = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  const { lang } = useContext(Language);
  const prevLangRef = useRef(lang);

  // Reset expanded state when language changes
  useEffect(() => {
    if (prevLangRef.current && prevLangRef.current !== lang) {
      setExpanded(false);
    }
    prevLangRef.current = lang;
  }, [lang]);

  const toggleReadMore = () => {
    setExpanded(prev => !prev);
  };

  const processTextWithHashtags = (text) => {
    if (!text) return null;

    return text
      .split(/(#[\w]+)|(\n)|(http\S+)/g)
      .map((part, index) => {
        if (!part) return null;

        if (part.startsWith("#")) {
          return (
            <span
              key={`hashtag-${index}`}
              className="cursor app-btn-color"
            >
              {part}
            </span>
          );
        }

        if (part.startsWith("http")) {
          return (
            <a
            className="text-underline app-btn-colo"
              key={`url-${index}`}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
            >
              {part}
            </a>
          );
        }

        if (part === "\n") {
          return <br key={`br-${index}`} />;
        }

        return <span key={`text-${index}`}>{part}</span>;
      })
      .filter(Boolean);
  };

  if (!text) return null;

  const shouldShowSeeMore = text.length > 240;
const seemoreText = processTextWithHashtags(text?.slice(0, 240))
const _text = processTextWithHashtags(text)
  return (
    <div>
      {expanded ? (
        <p
          translate="no"
          className="roboto-regular readmore-text mb-0 fs-14"
          
        >
          {_text}
          <span
            translate="no"
            onClick={toggleReadMore}
            className="ms-2 roboto-bold text-blue cursor app-btn-color fs-14"
          >
            {lang?.see_less || "See less"}
          </span>
        </p>
      ) : (
        <p
          translate="no"
          className="roboto-regular mb-0 readmore-text fs-14"
        >
          {seemoreText}
          {shouldShowSeeMore && (
            <span>
              ...{" "}
              <span
                translate="no"
                onClick={toggleReadMore}
                className="roboto-bold text-blue app-btn-color cursor fs-14"
              >
                {lang?.see_more || "See more"}
              </span>
            </span>
          )}
        </p>
      )}
    </div>
  );
};